import { publish as publisher } from 'pubsub-js';
import { isAbortError } from './helpers';

export const publish = (type = '', message = '') => {
  if (isAbortError(message)) return null;
  publisher(type, message);
};
